/* Config */
export const GET_CONFIG = "GET_CONFIG";
export const GET_CONFIG_SUCCESS = "GET_CONFIG_SUCCESS";
export const GET_CONFIG_ERROR = "GET_CONFIG_ERROR";

export const GET_CONFIGS = "GET_CONFIGS";
export const GET_CONFIGS_SUCCESS = "GET_CONFIGS_SUCCESS";
export const GET_CONFIGS_ERROR = "GET_CONFIGS_ERROR";

export const GET_CONFIG_DEFAULT = "GET_CONFIG_DEFAULT";
export const GET_CONFIG_DEFAULT_SUCCESS = "GET_CONFIG_DEFAULT_SUCCESS";
export const GET_CONFIG_DEFAULT_ERROR = "GET_CONFIG_DEFAULT_ERROR";

export const ADD_CONFIG_KEY = "ADD_CONFIG_KEY";
export const ADD_CONFIG_KEY_SUCCESS = "ADD_CONFIG_KEY_SUCCESS";
export const ADD_CONFIG_KEY_ERROR = "ADD_CONFIG_KEY_ERROR";

export const MODIFY_CONFIG_KEY = "MODIFY_CONFIG_KEY";
export const MODIFY_CONFIG_KEY_SUCCESS = "MODIFY_CONFIG_KEY_SUCCESS";
export const MODIFY_CONFIG_KEY_ERROR = "MODIFY_CONFIG_KEY_ERROR";

export const DELETE_CONFIG_KEY = "DELETE_CONFIG_KEY";
export const DELETE_CONFIG_KEY_SUCCESS = "DELETE_CONFIG_KEY_SUCCESS";
export const DELETE_CONFIG_KEY_ERROR = "DELETE_CONFIG_KEY_ERROR";
